import React from 'react';
import { MdClose } from 'react-icons/md';
import './Popup.css';

const Popup = ({ project, onClose }) => {
    return (
        <div className='app__popup-overlay'>
            <div className="app__popup">
                <div className="app__popup-content">
                    <h2 className='p__cormorant' style={{color: '#D9FFFC'}}>{project.title}</h2>
                    <p className='app__popup-content_description'>{project.description}</p>
                    <MdClose fontSize={27} className='app__popup-closeButton' onClick={onClose} />
                    <a href={project.link} className='app__popup-projectLink' target="_blank" rel="noopener noreferrer">
                        <button className='custom__button'>Go to Project</button>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Popup;